import styled from 'styled-components';

// eslint-disable-next-line import/prefer-default-export
export const ButtonCollapse = styled.div`
  width: 100%;
  text-align: right;
  margin-bottom: -17px;
  padding-right: 11px;
`;
